import { useEffect, useRef, useState, FC } from 'react';

import Wrapper from './Wrapper';
import FolderRow from './components/Folder';
import { Folder, RenameFolderProps } from './types';

type FolderTreeProps = {
  data: Folder[];
  newFolderId: number | null;
  selectedFolderId?: number;
  onSelectRow: (id: number | string) => void;
  onExpandFolder: (id: string) => void;
  isInputFocused: (folderId: number) => boolean;
  onRenameFolder: (props: RenameFolderProps) => void;
};

export * from './types';

const FolderTree: FC<FolderTreeProps> = ({ data, newFolderId, onSelectRow, selectedFolderId, ...restProps }) => {
  const [activeRow, setActive] = useState<string | number>('');
  const listRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (newFolderId) {
      setActive(newFolderId);
      onSelectRow(newFolderId);
    }
  }, [newFolderId]);

  useEffect(() => {
    if (!listRef.current || !selectedFolderId) return;

    setActive(selectedFolderId);
    const selectedFolder = document.querySelector(`[data-folder-id="${selectedFolderId}"]`);

    selectedFolder && selectedFolder.scrollIntoView({ block: 'start' });
  }, [listRef.current]);

  return (
    <Wrapper ref={listRef}>
      {data.map(folder => (
        <FolderRow key={folder.id} {...{ ...folder, ...restProps, onSelectRow, setActive, activeRow }} />
      ))}
    </Wrapper>
  );
};

export default FolderTree;
